import {
  ResourceCategoryEnum,
  ResourceTeacherInstruction,
} from '@protos/content_management/content.db_pb';
import { IStyles } from '../../../../commonUtils/styleUtils';
import ElementRenderer from '../../ElementRenderer';
const styles: IStyles = {};
interface IProps {
  teacherInstruction: ResourceTeacherInstruction;
  resourceCategory?: ResourceCategoryEnum;
  disableDownload?: boolean;
}
export const ResourceTeacherInstructionElement = (props: IProps) => {
  const { teacherInstruction, resourceCategory, disableDownload } = props;
  const elements = teacherInstruction.instructionContent?.elements;
  if (!elements) {
    return null;
  }
  return (
    <ElementRenderer
      disableDownload={disableDownload}
      elements={elements}
      resourceCategory={resourceCategory}
    />
  );
};
